import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';

const { TextArea } = Input;

interface CreateIssueProps {
  vehicleName: string;
  closeDropdown: () => void;
}

const CreateIssue = ({ vehicleName, closeDropdown }: CreateIssueProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const { cockpitNumber } = useSelector((state: RootState) => state.newCommon);

  const showModal = () => {
    setIsModalVisible(true);
    closeDropdown();
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        setIsLoading(true);
        try {
          const res = await request({
            path: '/ticket/operate/create-ticket',
            method: Method.POST,
            body: {
              vehicleName,
              alertDescription: values.description,
              cockpitNumber,
            },
          });

          if (res.code === HttpStatusCode.Success) {
            message.success('工单创建成功!');
            setIsModalVisible(false);
          } else {
            message.error(res.message || '工单创建失败');
          }
        } catch (error: any) {
          message.error(error.message || '请求失败');
        } finally {
          setIsLoading(false);
        }
      })
      .catch((info) => {
        console.log('表单验证失败:', info);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const afterClose = () => {
    form.resetFields();
  };

  return (
    <>
      <button className="issue-command-btn" onClick={showModal}>
        创建工单
      </button>
      <Modal
        title="创建工单"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="确认"
        cancelText="取消"
        afterClose={afterClose}
        confirmLoading={isLoading}
      >
        <Form form={form} layout="vertical" name="create_issue_form">
          <Form.Item
            name="description"
            label="描述"
            rules={[
              {
                required: true,
                message: '请输入描述',
              },
              {
                max: 30,
                message: '描述不能超过30个字符',
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="必填，最多30字"
              maxLength={30}
              showCount
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default React.memo(CreateIssue);
